import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M73.8504 41.1899C73.8504 41.1899 60.2904 34.2999 56.2404 29.5699C51.7404 24.3099 51.9404 1.66992 51.9404 1.66992H39.5204C39.5204 1.66992 39.8304 24.4199 35.2204 29.5699C30.3304 35.0299 17.6104 40.9899 17.6104 40.9899C23.8004 55.5699 36.2003 59.2899 45.7303 59.2899C55.2603 59.2799 67.6604 55.7699 73.8504 41.1899Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M24.8408 34.4199C24.8408 34.4199 31.0908 44.6599 44.8208 44.6599C60.0108 44.6599 66.6208 34.4199 66.6208 34.4199"
        stroke="#C375AF"
        fill="none"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M61.8904 32.26C65.4304 34.14 75.6104 39.54 77.5004 40.49C82.1704 42.84 85.8204 46.08 87.3804 58.09C88.6804 68.38 89.3004 71.91 89.3004 71.91H2.15039C2.15039 71.91 2.59039 69.16 4.07039 58.09C5.72039 46.47 9.28038 42.84 13.9504 40.49C15.8604 39.53 25.3404 34.51 29.1704 32.47C29.1704 32.47 31.4704 37.73 38.9504 40.17C40.8104 40.78 42.1504 41.41 43.2104 42.19C44.7704 43.33 45.3704 44.13 45.3704 44.13C45.3704 44.13 46.9204 42.21 51.3104 40.57C60.4204 37.18 61.8904 32.26 61.8904 32.26Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M45.6497 65.1699C46.2075 65.1699 46.6597 64.7177 46.6597 64.1599C46.6597 63.6021 46.2075 63.1499 45.6497 63.1499C45.0919 63.1499 44.6396 63.6021 44.6396 64.1599C44.6396 64.7177 45.0919 65.1699 45.6497 65.1699Z"
        fill={outline}
      />
      <path
        d="M45.6497 57.8999C46.2075 57.8999 46.6597 57.4477 46.6597 56.8899C46.6597 56.3321 46.2075 55.8799 45.6497 55.8799C45.0919 55.8799 44.6396 56.3321 44.6396 56.8899C44.6396 57.4477 45.0919 57.8999 45.6497 57.8999Z"
        fill={outline}
      />
      <path
        d="M45.6497 50.6198C46.2075 50.6198 46.6597 50.1677 46.6597 49.6098C46.6597 49.052 46.2075 48.5999 45.6497 48.5999C45.0919 48.5999 44.6396 49.052 44.6396 49.6098C44.6396 50.1677 45.0919 50.6198 45.6497 50.6198Z"
        fill={outline}
      />
      <path
        d="M25.3701 35.4099C25.3701 35.4099 27.8701 39.9299 33.3401 42.6399C38.8101 45.3499 42.9301 45.6799 42.9301 54.4599C42.9301 63.2399 42.9301 68.0999 42.9301 68.0999H48.3301C48.3301 68.0999 48.3301 63.2299 48.3301 54.4599C48.3301 45.6899 52.4501 45.3399 57.9201 42.6399C63.3901 39.9399 65.8901 35.4099 65.8901 35.4099"
        stroke={outline}
        fill="none"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M42.8604 52.9698C42.8604 52.9698 42.7904 44.2598 50.2204 41.5598"
        stroke={outline}
        fill="none"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="45.7274"
          y1="42.8398"
          x2="45.7274"
          y2="8.80712"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
